var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 25.6055C11.832 25.6055 13.332 27.1055 13.332 28.9388C13.332 30.7721 11.832 32.2721 9.9987 32.2721C8.16536 32.2721 6.66536 30.7721 6.66536 28.9388C6.66536 27.1055 8.16536 25.6055 9.9987 25.6055ZM9.9987 22.2721C6.33203 22.2721 3.33203 25.2721 3.33203 28.9388C3.33203 32.6055 6.33203 35.6055 9.9987 35.6055C13.6654 35.6055 16.6654 32.6055 16.6654 28.9388C16.6654 25.2721 13.6654 22.2721 9.9987 22.2721ZM19.9987 8.9388C21.832 8.9388 23.332 10.4388 23.332 12.2721C23.332 14.1055 21.832 15.6055 19.9987 15.6055C18.1654 15.6055 16.6654 14.1055 16.6654 12.2721C16.6654 10.4388 18.1654 8.9388 19.9987 8.9388ZM19.9987 5.60547C16.332 5.60547 13.332 8.60547 13.332 12.2721C13.332 15.9388 16.332 18.9388 19.9987 18.9388C23.6654 18.9388 26.6654 15.9388 26.6654 12.2721C26.6654 8.60547 23.6654 5.60547 19.9987 5.60547ZM29.9987 25.6055C31.832 25.6055 33.332 27.1055 33.332 28.9388C33.332 30.7721 31.832 32.2721 29.9987 32.2721C28.1654 32.2721 26.6654 30.7721 26.6654 28.9388C26.6654 27.1055 28.1654 25.6055 29.9987 25.6055ZM29.9987 22.2721C26.332 22.2721 23.332 25.2721 23.332 28.9388C23.332 32.6055 26.332 35.6055 29.9987 35.6055C33.6654 35.6055 36.6654 32.6055 36.6654 28.9388C36.6654 25.2721 33.6654 22.2721 29.9987 22.2721Z",
    fill: "url(#paint0_linear_5661_35482)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5661_35482",
    x1: -57.2771,
    y1: -37.9869,
    x2: 64.6647,
    y2: -62.2555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandoff);
export default __webpack_public_path__ + "static/media/handoff.e485f5b9d0e6c5c8cd1c556ab851fe8e.svg";
export { ForwardRef as ReactComponent };